import React from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';

const AcademicYearFormModal = ({
  show,
  onHide,
  onSubmit,
  formData,
  onInputChange,
  submitting,
  editingYear,
  error,
}) => (
  <Modal show={show} onHide={onHide} size="lg">
    <Modal.Header closeButton>
      <Modal.Title>
        {editingYear ? 'Edit Academic Year' : 'Create New Academic Year'}
      </Modal.Title>
    </Modal.Header>
    <Form onSubmit={onSubmit}>
      <Modal.Body>
        {error && (
          <Alert variant="danger" onClose={() => {}} dismissible>
            {error}
          </Alert>
        )}
        <Form.Group className="mb-3">
          <Form.Label>
            Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={formData.name}
            onChange={onInputChange}
            placeholder="e.g., 2025-2026"
            required
          />
        </Form.Group>
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>
                Start Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={onInputChange}
                required
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>
                End Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={onInputChange}
                required
              />
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              Saving...
            </>
          ) : (
            <>{editingYear ? 'Update' : 'Create'}</>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  </Modal>
);

export default AcademicYearFormModal;
